import type { ConnectedAccount } from '@/settings/schemas/external-storage-schema'

export function pickVisibleAccount(accounts: ConnectedAccount[]): ConnectedAccount | null {
  // Backend enforces one active external storage account per user via
  // external_storage_account_one_active_per_user_idx. Sorting is defensive for
  // stale responses or local test fixtures that contain more than one visible row.
  const visible = accounts
    .filter((account) => account.status !== 'disconnected')
    .sort((a, b) => {
      const aTs = a.connected_at ? Date.parse(a.connected_at) : 0
      const bTs = b.connected_at ? Date.parse(b.connected_at) : 0
      return bTs - aTs
    })

  return visible[0] ?? null
}
